<template>
  <div>
    <label id="commentHeading" for="comment"> {{ $t('Additional information') }}</label>
    <br />
    <label id="commentSubHeading" for="comment">{{
      $t('If necessary, please specify your question or add any additional information relevant for our meeting')
    }}</label>
    <VeeForm @submit="validate()">
      <Field
        mode="passive"
        name="comments"
        :rules="`${commentsRequired ? 'required' : ''}`"
        v-model="comments"
        :validateOnBlur="false"
        :validateOnChange="false"
        :validateOnInput="false"
        :validateOnModelUpdate="false"
      >
        <template #default="{ field, errors }">
          <div class="input-container">
            <div class="textarea__wrapper">
              <textarea name="comment" id="comment" class="textarea" v-bind="field"></textarea>
            </div>
            <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
          </div>
        </template>
      </Field>
      <div class="button__wrapper">
        <button class="button button--primary mr-2" type="submit">{{ $t('Continue') }}</button>
      </div>
    </VeeForm>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useBookingStore } from '../store'
import { Field, Form } from 'vee-validate'
export default {
  name: 'CommentSection',
  components: {
    Field,
    VeeForm: Form,
  },
  data() {
    return {
      errorList: [],
    }
  },
  computed: {
    ...mapState(useBookingStore, [
      'services',
      'groupValue',
      'appointmentLang',
      'appointmentType',
      'subUnits',
      'groupedSubUnits',
      'branchType',
      'appCountry',
      'bookingErrors',
      'selectedBranch',
      'selectedDate',
      'selectedTime',
      'comment',
      'sessionId',
      'appLang',
      'childrenCount',
      'selectedServiceObject',
      'childCount',
    ]),
    comments: {
      get() {
        return this.comment
      },
      set(value) {
        this.setComment(value)
      },
    },
    commentsRequired() {
      const EEFPAppointmentTypes = [
        'daily_banking',
        'inheritence',
        'custody_related_actions',
        'operations_with_professional_accounts',
      ]
      if (
        this.appCountry == 'LV' &&
        this.groupValue == 'JP' &&
        (this.branchType == 'video' || this.branchType == 'regular')
      ) {
        return this.appointmentType == 'daily_banking'
      } else if (
        this.appCountry == 'EE' &&
        this.groupValue == 'JP' &&
        (this.branchType == 'video' || this.branchType == 'regular')
      ) {
        return this.appointmentType == 'other_services'
      } else if (
        this.appCountry == 'LT' &&
        this.groupValue == 'JP' &&
        (this.branchType == 'video' || this.branchType == 'regular')
      ) {
        return this.appointmentType == 'other_services'
      } else if (
        this.appCountry == 'EE' &&
        this.groupValue == 'FP' &&
        (this.branchType == 'video' || this.branchType == 'regular')
      ) {
        return EEFPAppointmentTypes.includes(this.appointmentType)
      } else {
        return false
      }
    },
  },
  watch: {},
  methods: {
    ...mapActions(useBookingStore, [
      'setErrors',
      'clearErrors',
      'setComment',
      'setSessionId',
      'allowPersonalView',
      'reserveAppointment',
    ]),
    forward() {
      //to-do logic for checking for empty fields
      this.clearErrors() //clear all errors on submit
      if (this.selectedDate == '' || this.selectedDate == null) {
        this.setErrors('date')
      }
      if (this.branchType == 'regular' && this.selectedBranch == '') {
        this.setErrors('branch')
      }
      if (this.selectedTime == '') {
        this.setErrors('time')
      }
      //check for child input
      if (
        this.selectedServiceObject &&
        (this.selectedServiceObject.show_child_input_branch || this.selectedServiceObject.show_child_input_video)
      ) {
        this.childrenCount ? '' : this.setErrors('children')
      }
      if (this.branchType == '') {
        this.setErrors('branchType')
      }
      //redirect to personal info view
      if (this.bookingErrors.length == 0) {
        this.generateSessionId() //generate session id
        this.initReserveAppointment() //post to new endpoint
        this.allowPersonalView(true) // allow navigation to personal view
        this.$router.push('/personal') //redirect to personal info
      }
    },
    generateSessionId() {
      let currentTime = performance.now().toString()
      let randomNumber = (Math.random() * 1000000).toString()
      let uniqueId = btoa(currentTime + randomNumber) //base64 encoding
      if (this.sessionId && this.sessionId !== '') {
        this.setSessionId(this.sessionId)
      } else {
        this.setSessionId(uniqueId) //set session id in state
      }
    },
    initReserveAppointment() {
      var appointmentDataObject = new FormData()

      appointmentDataObject.append('lang', this.appLang)
      appointmentDataObject.append('country', this.appCountry)
      appointmentDataObject.append('group', this.groupValue)
      appointmentDataObject.append('sub_unit_id', this.selectedBranch.id)
      appointmentDataObject.append('appointment_type_id', this.selectedBranch.appointment_type_id)
      appointmentDataObject.append('date', this.selectedDate)
      appointmentDataObject.append('time_slot', this.selectedTime.time_slot)
      appointmentDataObject.append('meeting_lang', this.appointmentLang)
      appointmentDataObject.append('session_id', this.sessionId)

      if (this.comment.length) {
        appointmentDataObject.append('comments', this.comment)
      }
      if (this.childrenCount) {
        appointmentDataObject.append('children_count', this.childrenCount)
      }
      this.reserveAppointment(appointmentDataObject)
    },
    async validate() {
      this.forward()
    },
  },
}
</script>
